import { Template } from "@/interfaces/template.interface";
import TemplateList from "./TemplateList";
import { ReactNode } from "react";

interface TemplateFilter {
  artworkId?: string;
  cropSettingsId?: string;
}

interface Props {
  filter?: TemplateFilter;
  header?: ReactNode;
  onChange?: (item?: Template) => void;
  onSelect?: (items: Template[]) => void;
  onRemove?: (item: Template) => void;
}

export default function TemplateManagement({
  filter,
  header,
  onChange,
  onSelect,
  onRemove,
}: Props) {
  return (
    <div className="flex h-full w-full flex-1 overflow-auto">
      <div className="h-full flex-1 overflow-auto">
        <TemplateList
          filter={filter}
          header={header}
          onChange={onChange}
          onSelect={onSelect}
          onRemove={onRemove}
        />
      </div>
    </div>
  );
}
